import CategoriesOverview from '../../features/categories/layouts/overview';

// TSS vite/01 — pages are thin; they mount a feature layout.
export default function CategoriesPage() {
    return <CategoriesOverview />;
}
